import moment from './moment'
import { resolveLocaleString } from './locale'

// Note: Backend provides timezone_offset that already accounts for DST for the specific meeting date.
// We keep the dstShiftHours parameter for backward compatibility but ignore it to prevent double-shifting.
export const getTimeWithTimezoneOffset = (time, offset, locale = '', dstShiftHours = 0) => {
  const localeStr = resolveLocaleString(locale)
  if (localeStr && typeof moment.locale === 'function') {
    moment.locale(localeStr)
  }

  if (!time || !moment(time).isValid()) {
    return moment() // If no valid time is provided, return current time
  }

  const offsetNumber = Number(offset)

  // If no offset or offset is 0, fallback to user's current offset/local time
  if (Number.isNaN(offsetNumber) || offsetNumber === 0) {
    const currentOffset = moment().utcOffset()

    // If the user's timezone offset is 0, return time with that offset
    if (currentOffset === 0) {
      return moment(time).utcOffset(currentOffset)
    }

    return moment(time) // Use local time if no specific offset
  }

  // Apply the specific offset (DST assumed included by backend)
  return moment(time).utcOffset(offsetNumber)
}

// Return the given time converted to the user's local timezone (DST-aware for that timestamp)
export const getLocalTimeForDate = (time, locale = '') => {
  const localeStr = resolveLocaleString(locale)
  if (localeStr && typeof moment.locale === 'function') {
    moment.locale(localeStr)
  }
  if (!time || !moment(time).isValid()) {
    return moment()
  }
  // moment(time) without utcOffset forces local zone rules incl. DST for that date
  return moment(time)
}

// Format the user's local offset (for that specific time) as GMT±H[:MM]
export const formatLocalOffsetForDate = (time) => {
  const m = moment(time)
  if (!time || !m.isValid()) {
    return 'GMT'
  }
  const n = m.utcOffset() // minutes for that timestamp, includes DST
  const sign = n >= 0 ? '+' : '-'
  const abs = Math.abs(n)
  const hours = Math.floor(abs / 60)
  const minutes = abs % 60
  if (minutes === 0) {
    return `GMT${sign}${hours}`
  }
  const mm = minutes.toString().padStart(2, '0')
  return `GMT${sign}${hours}:${mm}`
}
